export default __webpack_public_path__ + "static/media/Default_Screen.21073ab2.png";